// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const USER_DEFINED_FUNCTION_STEP_SHAPES = [
  {
    stepType: PipelineStepType.USER_DEFINED_FUNCTION,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input datasets': {
        systemName: 'Input datasets',
        displayName: 'Input datasets',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      },
      'Input files': {
        systemName: 'Input files',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      }
    },
    outputDataShapes: {
      'Output datasets': {
        systemName: 'Output datasets',
        displayName: 'Output datasets',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      },
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      },
      'Output charts': {
        systemName: 'Output charts',
        displayName: 'Output charts',
        kind: PipelineStepDataKind.CHART,
        isMulti: true,
        isRequired: false
      },
      'Standard output': {
        systemName: 'Standard output',
        displayName: 'Standard output',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      },
      'Standard error': {
        systemName: 'Standard error',
        displayName: 'Standard error',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      },
      Report: {
        systemName: 'Report',
        displayName: 'Report',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    config: {
      userDefinedCode: {
        kind: 'string',
        required: true
      },
      name: {
        kind: 'string',
        required: false
      },
      params: {
        kind: 'anything',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
